// TableProvider.jsx
import React from 'react';
import {useTableToggle} from './hooks/useTableToggle';

const TableContext = React.createContext(null);

export const TableProvider = ({ tableId, children }) => {
    const { toggle, isOpened } = useTableToggle(tableId);

    return (
        <TableContext.Provider value={{ toggle, isOpened }}>
            {children}
        </TableContext.Provider>
    );
};

export const useTableContext = () => React.useContext(TableContext);